/*
 * =============================================================================
 * Project: payments.telestrada-online.pl
 * Created Date: 2018-07-27, 10:14:18
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-07-27, 10:19:47
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import MessageInfoAnimatedIconForStatus from './MessageInfoAnimatedIconForStatus';

export default {
  name: 'MessageInfo',

  components: { MessageInfoAnimatedIconForStatus },

  props: {
    messageType: {
      type: String,
      default: 'success',
    },
    title: {
      type: String,
      default: 'Title',
    },
    code: {
      type: String,
      default: '200',
    },
    description: {
      type: String,
      default: 'Description',
    },
  },

  computed: {
    codeColor() {
      return ({
        success: 'color: #33691e',
        error: 'color: #c62828',
      })[this.messageType];
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Common/MessageInfo/component.js